import { useState, useEffect } from 'react'
import { Modal, ModalBody } from 'reactstrap'
import s from './CreateProposalModal.scss'
import { HtmlEditor, InputContainer } from 'components/ideal-core-ui'
import Select from 'react-select'
import { toTemplates } from './serializers'
import { useLoading } from 'hooks'
import { makeGetRequest } from 'utils/api'

const pageTypes = [
  { value: 'a4', label: 'A4' },
  { value: 'letter', label: 'Letter' }
]

const CreateProposalModal = ({
  setIsCreateHtmlProposalModalVisible,
  isCreateHtmlProposalModalVisible,
  pages,
  resetPages,
  categories,
  saveTemplate,
  template,
  setTemplate,
  templates,
  setPages
}) => {
  const [pageType, setPageType] = useState(template?.pageType ?? 'letter')
  const [templateTitle, setTemplateTitle] = useState(template?.name ?? '')
  const [initialTemplate, setInitialTemplate] = useState('')
  const [, withLoadingLocks] = useLoading()

  useEffect(() => {
    initialTemplate && setPages(initialTemplate.content)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialTemplate])

  const closeModal = () => {
    setIsCreateHtmlProposalModalVisible(!isCreateHtmlProposalModalVisible)
    resetPages()
    setPageType('a4')
    setTemplateTitle('')
  }

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isCreateHtmlProposalModalVisible}
        toggle={closeModal}
        size="xl"
        className={s.modal}
      >
        <ModalBody className={s.modalBody}>
          <InputContainer
            type="text"
            style={{
              display: 'inline'
            }}
            placeholder="Template Name"
            cb={value => setTemplateTitle(value)}
            text={templateTitle}
            classname={s.title}
          />
          <Select
            placeholder="Proposal Layouts"
            onChange={async value => {
              const { content } = await withLoadingLocks(
                makeGetRequest(`/v1/proposaltemplates/${value.value}`)
              )
              setInitialTemplate({ ...value, content: JSON.parse(content) })
            }}
            options={toTemplates(templates)}
            className={s.layoutSelect}
          />
          <Select
            placeholder="Page Type"
            value={pageType.value ? pageType : pageTypes.find(t => t.value === pageType)}
            onChange={value => setPageType(value.value)}
            options={pageTypes}
            className={s.layoutSelect}
          />
          <HtmlEditor
            pageType={pageType}
            pages={pages}
            categories={categories}
            actions={[
              {
                text: 'Save',
                cb: (json, html) => {
                  saveTemplate(JSON.stringify(json), html, { name: templateTitle, pageType })
                },
                className: s.saveBtn,
                enabled: templateTitle
              },
              {
                text: 'Cancel',
                cb: () => {
                  closeModal()
                  setTemplate({})
                }
              }
            ]}
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default CreateProposalModal
